
var XLSXSaver = function () {
    var self = this
    self.saveAs = function (result, fileName) {
        let xlsxData = result.xlsxData
        result.exportedTable.export2file(xlsxData.data, xlsxData.mimeType, fileName, xlsxData.fileExtension, xlsxData.merges, xlsxData.RTL, xlsxData.sheetname)
    }
}
export default new XLSXSaver();